/** D470 (F-006): the operator's reads and vetoes of a driver's payment methods (`driver:view` / `driver:suspend`). */
export class DriverPaymentMethodsAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    get(input) {
        return this.client.request({ method: 'GET', path: `/v1/admin/drivers/${encodeURIComponent(input.driverId)}/payment-methods?market=${encodeURIComponent(input.marketId)}`, auth: true });
    }
    /** Veto (`vetoed: true`) or lift (`false`) one method for the driver, with a stable reason code and an optional note. */
    veto(input) {
        return this.client.request({
            method: 'PUT',
            path: `/v1/admin/drivers/${encodeURIComponent(input.driverId)}/payment-methods/${encodeURIComponent(input.method)}/veto?market=${encodeURIComponent(input.marketId)}`,
            body: { vetoed: input.vetoed, reasonCode: input.reasonCode, ...(input.note !== undefined ? { note: input.note } : {}) },
            auth: true,
        });
    }
}
export class DriverPaymentMethodsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The driver's party-settled methods and whether each is accepted, with its source. */
    get() {
        return this.client.request({ method: 'GET', path: '/v1/driver/payment-methods', auth: true });
    }
    /** Record whether the driver accepts a party-settled method (e.g. `{ method: 'cash', accepts: false }`). */
    set(input) {
        return this.client.request({ method: 'PUT', path: '/v1/driver/payment-methods', body: input, auth: true });
    }
}
//# sourceMappingURL=driver-payment-methods.js.map